import { useEffect, useState } from "react";
import { createClickableLink } from "../../../../components/common/datatable/DataTableUtils";
import { SearchInputWrapper } from "../../../../components/common/datatable/filter/SearchInputWrapper";
import Breadcrumb from "../../../../components/common/Breadcrumbs";
import { DataTable } from "../../../../components/common/datatable/DataTable";
import { DataTableColumn } from "../../../../components/common/datatable/DataTableTypes";
import { useLazyExportTaxRollDataQuery, useSearchTaxRollQuery } from "../taxRollApi";
import CollectorSearchInputWrapper from "../../../../components/common/datatable/filter/CollectorSearchInputWrapper";
import { useFindUserSettingsByGroupNameQuery } from "../../../../components/common/userSetting/userSettingsApi";

const TaxRoll = () => {

    const [crumbs] = useState([
        { content: "Home", url: "/home" },
        { content: "Tax Rolls", url: "" }]
    )

    const { data: userSetting } = useFindUserSettingsByGroupNameQuery("Tax Roll");
    useEffect(() => {
        document.title = 'Tax Rolls';
    }, []);

    const [triggerExportTaxRollDataQuery] = useLazyExportTaxRollDataQuery();


    const columns: DataTableColumn[] = [
        {
            label: "Tax Account No.", accessor: "taxAccountNumber",
            cell: (props: any) => {
                let path = "/tax-rolls/" + props.row.original.id;
                return createClickableLink(path, props.value, userSetting);
            },
            filterOptions: [{
                filterComponent: <SearchInputWrapper type={"text"} placeholder={"Enter Tax Account No..."}
                    accessor={"taxAccountNumber"} />,
                overrideFilterLabel: "Tax Account No.",
                overrideFilterAccessor: "taxAccountNumber"
            }]
        },
        {
            label: "Collector", accessor: "collectorId", visibility: { hasShowSetting: false },
            cell: (props: any) => {
                return (<span>{props.row.original.collectorName}</span>)
            },
            filterOptions: [{
                filterComponent: <CollectorSearchInputWrapper accessor="collectorId" />,
                overrideFilterAccessor: "collectorId",
                overrideFilterLabel: "Collector",
            }]
        },
        {
            label: "Appraisal District No.", accessor: "appraisalDistrictNumber",
            filterOptions: [{
                filterComponent: <SearchInputWrapper type={"text"} placeholder={"Enter Appraisal District No..."}
                    accessor={"appraisalDistrictNumber"} />,
                overrideFilterLabel: "Appraisal District No.",
                overrideFilterAccessor: "appraisalDistrictNumber"
            }]
        },
        {
            label: "Tax Year", accessor: "taxYear",
            filterOptions: [{
                filterComponent: <SearchInputWrapper type={"number"} placeholder={"Enter Tax Year..."}
                    accessor={"taxYear"} />,
                overrideFilterLabel: "Tax Year",
                overrideFilterAccessor: "taxYear"
            }]
        },
        {
            label: "Base Tax", accessor: "baseTax",
            filterOptions: [{
                filterComponent: <SearchInputWrapper type={"number"} placeholder={"Enter Base Tax..."}
                    accessor={"baseTax"} />,
                overrideFilterLabel: "Base Tax",
                overrideFilterAccessor: "baseTax"
            }]
        },
        {
            label: "Suit No.", accessor: "suitNumber",
            filterOptions: [{
                filterComponent: <SearchInputWrapper type={"text"} placeholder={"Enter Suit No..."}
                    accessor={"suitNumber"} />,
                overrideFilterLabel: "Suit No.",
                overrideFilterAccessor: "suitNumber"
            }]
        }
    ]

    return (
        <div className="user-container px-5 py-5">
            <div className="flex justify-between">
                <Breadcrumb crumbs={crumbs} />
            </div>

            <div className="table_data mt-2">
                <DataTable
                    columns={columns}
                    actions={{
                        fetchAction: useSearchTaxRollQuery,
                        exportAction: triggerExportTaxRollDataQuery
                    }}
                    userSettingGroup={"Tax Roll"}
                    defaultSortOptions={{
                        accessor: "collectorId",
                        direction: "asc"
                    }}
                    defaultFilter={{
                        pageNumber: 0,
                        pageSize: 25,
                        sort: "collectorId",
                        sortOrder: "ASCENDING"
                    }}
                    basePermission={"TAXROL"}

                />
            </div>
        </div>

    );
};

export default TaxRoll;